var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "#F1F1F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0194 3.55C11.1501 3.55 11.2574 3.59667 11.3414 3.69C11.4348 3.774 11.4814 3.88133 11.4814 4.012V11.544C11.4814 11.684 11.4348 11.796 11.3414 11.88C11.2574 11.964 11.1501 12.006 11.0194 12.006H8.96143C8.83076 12.006 8.72343 11.964 8.63943 11.88C8.55543 11.796 8.51343 11.684 8.51343 11.544V4.012C8.51343 3.88133 8.55543 3.774 8.63943 3.69C8.72343 3.59667 8.83076 3.55 8.96143 3.55H11.0194ZM11.0194 12.804C11.1501 12.804 11.2574 12.8507 11.3414 12.944C11.4348 13.0373 11.4814 13.1493 11.4814 13.28V15.044C11.4814 15.184 11.4348 15.296 11.3414 15.38C11.2574 15.464 11.1501 15.506 11.0194 15.506H8.96143C8.83076 15.506 8.72343 15.464 8.63943 15.38C8.55543 15.296 8.51343 15.184 8.51343 15.044V13.28C8.51343 13.1493 8.55543 13.0373 8.63943 12.944C8.72343 12.8507 8.83076 12.804 8.96143 12.804H11.0194Z",
    fill: "#FF5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/Caution.d0729c8439e152b7396ae566778adad5.svg";
export { ForwardRef as ReactComponent };